export default {
    callable: (element: HTMLElement) => {
        const srcSetElements = element.querySelectorAll(
            'img[data-distribution-srcset]'
        );
        [].forEach.call(srcSetElements, (img: HTMLImageElement) => {
            img.onload = () => {
                if (img.parentNode) {
                    const src = img.currentSrc ? img.currentSrc : img.src;
                    const parent = img.parentNode as HTMLElement;
                    parent.style.backgroundImage = `url("${src}")`;
                }
            };
        });
    },
};
